import { PageId } from 'constants/pages'

export const enum PageIdWoofzInvx {
  SUBSCRIPTIONS_INVOXIA_INVX = PageId.SUBSCRIPTIONS_INVOXIA_INVX,
  INVOXIA_CONGRATULATIONS_INVX = PageId.INVOXIA_CONGRATULATIONS_INVX,
  INVOXIA_REVIEW_INVX = PageId.INVOXIA_REVIEW_INVX,
  INVOXIA_DETAILS_INVX = PageId.INVOXIA_DETAILS_INVX,
}
